import { render } from "./ButtonShow.vue?vue&type=template&id=518085c8&scoped=true"
import script from "./ButtonShow.vue?vue&type=script&lang=js"
export * from "./ButtonShow.vue?vue&type=script&lang=js"

import "./ButtonShow.vue?vue&type=style&index=0&id=518085c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-518085c8"]])

export default __exports__